<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
        <!--page body contant -->
            <!-- header  -->
            <div class="row row-replace add-m-b">
                <div class="col-md-6 col-p h5">MRF / RAISE NEW TICKET REQUEST FORM</div>
                <div class="col-md-6 top-corner-items col-p"> </div>
            </div>
        <!--end header row -->

         <ul class="nav nav-tabs nav-tabs-bottom">
            <li class="nav-item"><a class="nav-link active" href="#ticket-tab1" data-toggle="tab">Create Ticket</a></li>

         </ul>

         <div class="tab-content">
            <nav class="tab-pane active" id="ticket-tab1">
               <div class="row">
                  <div class="col-md-12">
                     <div class="col-lg-12">
                        <div class="row">
                           <div class="col-md-6 d-flex padding-right-2 padding-left-2">
                              <div class="card flex-fill add-mrf-card">
                                 <div class="card-body card-padding-bottom">
                                    <h3 class="card-title page-header0"><i class="fa fa-briefcase"></i>&nbsp;Site Details</h3>
                                    <hr>
                                    <ul class="personal-info">
                                       <li>
                                          <div class="title">Select Plant</div>
                                          <div class="text">
                                           <select class="form-control">
                                              <option>Select Plant</option>

                                           </select>
                                          </div>
                                       </li>
                                       <li>
                                          <div class="title">Plant Name</div>
                                          <div class="text">
                                             <h4 class="text-muted">Address</h4>
                                          </div>
                                       </li>
                                       <li>
                                          <div class="title">Contact</div>
                                          <div class="text">
                                             <h4 class="text-muted">Hiring Type</h4>
                                          </div>
                                       </li>
                                       <li>
                                          <div class="title">Email</div>
                                          <div class="text">
                                             <h4 class="text-muted">Qualification</h4>
                                          </div>
                                       </li>

                                    </ul>
                                 </div>
                              </div>
                           </div>
                           <div class="col-md-6 d-flex padding-left-2 padding-right-2">
                              <div class="card flex-fill add-mrf-card">
                                 <div class="card-body card-padding-bottom">
                                    <h3 class="card-title page-header0"> <i class="fa fa-user"></i>&nbsp;User Details</h3>
                                    <hr>
                                    <ul class="personal-info">
                                       <li>
                                          <div class="title">Name</div>
                                          <div class="text">
                                             <select class="form-control" disabled>
                                                <option>Admin</option>
                                                <option>two</option>
                                                <option>three</option>
                                                <option>four</option>
                                                <option>five</option>
                                             </select>
                                          </div>
                                       </li>
                                       <li>
                                          <div class="title">Contact</div>
                                          <div class="text">
                                             <select class="form-control">
                                                <option>one</option>
                                                <option>two</option>
                                                <option>three</option>
                                                <option>four</option>
                                                <option>five</option>
                                             </select>
                                          </div>
                                       </li>
                                       <li>
                                          <div class="title">Email</div>
                                          <div class="text">
                                             <select class="form-control">
                                                <option>one</option>
                                                <option>two</option>
                                                <option>three</option>
                                                <option>four</option>
                                                <option>five</option>
                                             </select>
                                          </div>
                                       </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 d-flex padding-right-2 padding-left-2">
                                <div class="card flex-fill add-mrf-card">
                                   <div class="card-body card-padding-bottom">
                                    <h3 class="card-title page-header0"><i class="fa fa-location-arrow"></i>&nbsp;Problem Details</h3>
                                    <hr>
                                    <ul class="personal-info">
                                       <li>
                                          <div class="title">Ticket Type</div>
                                          <div class="text">
                                             <select class="form-control">
                                                <option>Asset Support</option>
                                                <option>Service Suppoert</option>
                                             </select>
                                          </div>
                                       </li>
                                       <li>
                                          <div class="title">Category</div>
                                          <div class="text">
                                             <select class="form-control">
                                                <option>one</option>
                                                <option>two</option>
                                                <option>three</option>
                                                <option>four</option>
                                                <option>five</option>
                                             </select>
                                          </div>
                                       </li>
                                       <li>
                                          <div class="title">Type Of Complaint</div>
                                          <div class="text">
                                             <select class="form-control">
                                                <option>one</option>
                                                <option>two</option>
                                                <option>three</option>
                                                <option>four</option>
                                                <option>five</option>
                                             </select>
                                          </div>
                                       </li>
                                       <li>
                                          <div class="title">Concern</div>
                                          <div class="text">
                                             <select class="form-control">
                                                <option>one</option>
                                                <option>two</option>
                                                <option>three</option>
                                                <option>four</option>
                                                <option>five</option>
                                             </select>
                                          </div>
                                       </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                           <div class="col-md-6 d-flex padding-left-2 padding-right-2">
                            <div class="card flex-fill add-mrf-card">
                               <div class="card-body card-padding-bottom">
                                    <h3 class="card-title page-header0"> <i class="fa fa-book"></i>&nbsp;Vendor & items:</h3>
                                    <hr>
                                    <ul class="personal-info">
                                       <li>
                                          <div class="title">Barcode</div>
                                          <div class="text">
                                             <input type="text" class="form-control">
                                          </div>
                                       </li>
                                       <li>
                                          <div class="title">Item/Service receipt date</div>
                                          <div class="text">
                                             <input type="date" class="form-control">
                                          </div>
                                       </li>
                                       <li>
                                          <div class="title">Attachment</div>
                                          <div class="text">
                                             <input type="file" class="form-control">
                                          </div>
                                       </li>
                                    </ul>
                                    <!-- service support fields  -->
                                    <ul class="personal-info" style="display:none;">
                                       <li>
                                          <div class="title">Vendor</div>
                                          <div class="text">
                                           <select class="form-control">
                                              <option>vendor1</option>
                                              <option>vendor1</option>
                                              <option>vendor1</option>
                                           </select>
                                          </div>
                                       </li>
                                       <li>
                                          <div class="title">Item Code & Description</div>
                                          <div class="text">
                                             <select class="form-control">
                                                <option>item code</option>
                                                <option>item code</option>
                                                <option>item code</option>
                                             </select>
                                          </div>
                                       </li>
                                       <li>
                                          <div class="title">Item/Service receipt date</div>
                                          <div class="text">
                                            <input type="date" class="form-control">
                                          </div>
                                       </li>
                                       <li>
                                          <div class="title">Attachment</div>
                                          <div class="text">
                                             <input type="file" class="form-control">
                                          </div>
                                       </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                        </div>


                     </div>
                  </div>
               </div>
            </nav>


         </div>
         <footer class="row row-replace add-m-b">
            <div class="col-md-12 d-flex padding-left-2 padding-right-2">
             <div class="card flex-fill add-mrf-card">
                <div class="card-body card-padding-bottom">
                 <section class="row">
                     <div class="col-12 mt-15">
                    <h3 class="add-m-b0">Remarks:*</h3>
                    <p class="text-danger">Please Enter PURCHASE ORDER NO. BATCH NO., QUANTITY, Issues details and other parameters for helping you better!</p>
                  </div>
                     <textarea rows="3" class="form-control" placeholder="Type Remark here..."></textarea>
                  </section>
                  <section class="text-center add-p-tb">
                     <button class="btn btn-primary"> Create Ticket</button>

                  </section>

                  </div>
               </div>
            </div>
        </footer>

        <!--end page body contant -->
        </div>
    </div>
</div>
  <!-- /Page Wrapper -->







